import { ICreateTaskGroupModalProps } from "./definitions";
import Modal from "@amzn/awsui-components-react/polaris/modal";
import { CreateTaskGroupForm } from "../create-taskgroup-form/CreateTaskgroupForm";
import { useState } from "react";

export const CreateTaskGroupModal: React.FC<ICreateTaskGroupModalProps> = ({
  onCreate,
  visible,
  setVisible,
  parentCategory,
}: ICreateTaskGroupModalProps) => {
  const [resetForm, setResetForm] = useState(0);
  const onDismiss = (e: any) => {
    if (e.detail.reason === "overlay") return;
    setVisible(false);
    setResetForm(resetForm + 1);
  };
  return (
    <Modal onDismiss={onDismiss} visible={visible} header="Add task group">
      <CreateTaskGroupForm
        setVisible={setVisible}
        resetForm={resetForm}
        onCreate={onCreate}
        parentCategory={parentCategory}
      />
    </Modal>
  );
};
